module.exports = __webpack_public_path__ + "img/icon2.6e4b6661.svg";